module.exports = __webpack_public_path__ + "img/66.f4af3f31.png";